import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import './Header.css';

const Header = () => {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [mobileMenuOpen]);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="header-left">
            <div className="logo">
              <Link to="/" className="logo-text">Atmasakshi Foundation</Link>
            </div>
            {mobileMenuOpen && <div className="nav-overlay" onClick={toggleMobileMenu}></div>}
            <nav className={`nav ${mobileMenuOpen ? 'active' : ''}`}>
              <button className="nav-close-btn" onClick={toggleMobileMenu}><X size={28} /></button>
              <Link to="/" className="nav-link" onClick={toggleMobileMenu}>{t('home')}</Link>
              <Link to="/about" className="nav-link" onClick={toggleMobileMenu}>{t('about')}</Link>
              <Link to="/donation" className="nav-link" onClick={toggleMobileMenu}>{t('donation')}</Link>
              <Link to="/events" className="nav-link" onClick={toggleMobileMenu}>{t('events')}</Link>
              <Link to="/blogs" className="nav-link" onClick={toggleMobileMenu}>{t('blog')}</Link>
              <Link to="/contact" className="nav-link" onClick={toggleMobileMenu}>{t('contact')}</Link>
            </nav>
          </div>

          <div className="header-actions">
            <LanguageSwitcher />
            <Link to="/donation" className="btn btn-primary">{t('donate_now')}</Link>
            <button className="mobile-menu-btn" onClick={toggleMobileMenu}>
              <Menu size={24} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
